import { projectBalance } from "../interest";
/**
 * Calculates new account balance after one month
 *
 * @param savings Current account category, saving balance, monthly savings amount and interest rate for all saving account
 * @returns New balance after one month for each account
 */
export function calculateSavings(savings) {
    const results = [];
    for (const account of savings) {
        const newBalance = projectBalance(account.amount, account.monthlySavings, account.interest);
        results.push({ category: account.category, balance: newBalance });
    }
    return results;
}
